const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "月曜日の次は？", answers: ["火曜日"], image: null },
      { id: "q2", question: "火曜日の次は？", answers: ["水曜日"], image: null },
      { id: "q3", question: "水曜日の次は？", answers: ["木曜日"], image: null },
      { id: "q4", question: "木曜日の次は？", answers: ["金曜日"], image: null },
      { id: "q5", question: "金曜日の次は？", answers: ["土曜日"], image: null },
      { id: "q6", question: "土曜日の次は？", answers: ["日曜日"], image: null },
      { id: "q7", question: "日曜日の次は？", answers: ["月曜日"], image: null },
      { id: "q8", question: "週の最初の日は？", answers: ["月曜日"], image: null },
      { id: "q9", question: "週の最後の日は？", answers: ["日曜日"], image: null },
      { id: "q10", question: "一週間は何日ですか？", answers: ["7", "七"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "japanese",
  name: "さくら",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# クイズへようこそ
さくらがホストします。

曜日を知っていますか？

「こんにちは」とさくらに話しかけて始めましょう。`,
  voice: "Mizuki",
  versionQuestion: "このテンプレートには何問の質問が欲しいですか？",
};

export default quiz;
